import { plural } from '../tasks/due'

/**
 * Срок обслуживания машины одной строкой.
 *
 * Отвечает не «какая дата стоит в напоминании», а «когда за это браться»:
 * «Техосмотр просрочен на 12 дней», «Страховка через 5 дней». Точная дата
 * уходит в подсказку — она нужна, но реже, чем относительная.
 *
 * Живёт в домене по той же причине, что и describeDue для задач: тон
 * и формулировка должны совпадать в таблице консоли, в карточке машины
 * и везде, где этот срок ещё покажется. Расчёт делает сервер
 * (services/car_ops.py), здесь только слова.
 *
 * Тона намеренно разведены по смыслу, а не по числу дней:
 *   danger  — уже просрочено, действие требуется сейчас;
 *   warning — неделя и меньше, действие надо планировать;
 *   info    — месяц, попадает в поле зрения;
 *   neutral — дальше месяца, знать полезно, делать нечего.
 */
export function describeCarDue(due) {
  if (!due) return null

  const { label, days_left: days, overdue, date } = due
  const dateText = new Date(date).toLocaleDateString('ru', { dateStyle: 'medium' })

  if (overdue) {
    const late = Math.abs(days)
    return {
      tone: 'danger',
      isOverdue: true,
      label: `${label}: просрочен на ${late} ${plural(late, 'день', 'дня', 'дней')}`,
      short: `−${late} ${plural(late, 'день', 'дня', 'дней')}`,
      exact: `${label} — ${dateText}`,
    }
  }

  const tone = days <= 7 ? 'warning' : days <= 30 ? 'info' : 'neutral'
  const when =
    days === 0
      ? 'сегодня'
      : `через ${days} ${plural(days, 'день', 'дня', 'дней')}`

  return {
    tone,
    isOverdue: false,
    label: `${label}: ${when}`,
    short: days === 0 ? 'сегодня' : `${days} ${plural(days, 'дн.', 'дн.', 'дн.')}`,
    exact: `${label} — ${dateText}`,
  }
}
